// extracted by mini-css-extract-plugin
module.exports = {"standardPadding":"content_standardPadding__2QH0i"};